import React from "react";
import "./HeroSection.css";
const HeroSection = () => {
  return (
    <div class="hero-section-pre">
      {/* Heading */}
      <img src="/assets/img/Group394.png" alt="Coin" />
      <br />
      {/* Subtitle */}
      <p class="instant-approval-pre">
        Instant approval, low interest rates,
        <br />
        fully digital journey
      </p>
      <br />
      {/* Divider with text */}
      <div class="loan-eligility-pre">
        <div style={{ flex: 1, height: "1px", background: "#ddd" }} />
        <span style={{ fontSize: "13px", color: "#888", whiteSpace: "nowrap" }}>
          Check your loan eligibility instantly
        </span>
        <div style={{ flex: 1, height: "1px", background: "#ddd" }} />
      </div>
    </div>
  );
};
export default HeroSection;
